export default "__VITE_ASSET__B_tUVkE9__"